import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const createRealTimeCampaign = createAsyncThunk(
  "createRealTimeCampaign",
  async (requestData, thunkAPI) => {
    try {
      const apiClient = new APIClient();
      const response = await apiClient.post(`/api/v1/clients/notification/campaigns/real-time`, requestData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "Failed to create real-time campaign");
    }
  }
);

const createRealTimeCampaignSlice = createSlice({
  name: "createRealTimeCampaign",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetRealTimeCampaignState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createRealTimeCampaign.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createRealTimeCampaign.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createRealTimeCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetRealTimeCampaignState } = createRealTimeCampaignSlice.actions;
export default createRealTimeCampaignSlice.reducer; 